import styled from "styled-components/macro";
import { COLORES } from "../../constants";

export const Wrapper = styled.div`
  width: 100%;
  background-color: ${COLORES.RESULT_MODULE_BACKGROUND};
  margin-bottom: 2rem;
  border-radius: 0.25rem;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 2rem;
  font-weight: bold;
  color: ${COLORES.RESULT_MODULE_HEADER_FONT};
  background-color: ${COLORES.RESULT_MODULE_HEADER_BACKGROUND};
  border-radius: 0.25rem 0.25rem 0 0;

  p {
    line-height: 2rem;
    padding: 0 1rem;
  }

  button {
    padding: 0 1rem;
    border: none;
    color: ${COLORES.RESULT_MODULE_HEADER_FONT};
    background-color: transparent;
    cursor: pointer;

    :hover {
      color: ${COLORES.RESULT_MODULE_HEADER_FONT_HOVER};
    }

    :disabled {
      color: ${COLORES.RESULT_MODULE_HEADER_FONT_DISABLED};
      cursor: default;
    }
  }
`;

export const Content = styled.div`
  text-align:left;
  table {
    width: 100%;
    border-collapse: collapse;

    thead {
      tr {
        height: 1.5rem;
      }
    }
  }
`;

export const TrMassiveReAsign = styled.tr`
  background-color: ${COLORES.EXTRA_HEADER_BACKGROUND};
  height: 2rem;

  th {
    text-align: start;
  }

  p {
    display: inline;
    color: ${COLORES.EXTRA_HEADER_FONT};
    font-weight: bold;
    padding-left: 1rem;
  }

  input {
    margin-left: 0.5rem;
    vertical-align: middle;
    cursor: pointer;
  }

  button {
    margin-left: 0.5rem;
    padding: 0.2rem;
    border: none;
    color: ${COLORES.EXTRA_HEADER_FONT};
    background-color: transparent;
    cursor: pointer;

    :hover {
      color: ${COLORES.EXTRA_HEADER_HOVER};
    }

    :disabled {
      color: ${COLORES.EXTRA_HEADER_DISABLED};
      cursor: default;
    }
  }
`;

export const TrColumnTitlesReserva = styled.tr`
  background-color: ${COLORES.HEADER_ROW_BACKGROUND};

  th {
  width:5%;
  }
`;

export const ButtonTh = styled.th`
  button {
    border: none;
    border-radius: 0.2rem;
    margin-left: 0.25rem;
    cursor: pointer;
    background-color: ${COLORES.SORT_BUTTON_BACKGROUND};
    background-color: ${(props) => props.active && COLORES.SORT_BUTTON_ACTIVE};

    :hover {
      background-color: ${COLORES.SORT_BUTTON_HOVER};
    }

    :disabled {
      cursor: default;
      background-color: transparent;
    }
  }
`;
export const TrDropdownGestoriaProvincia = styled.tr`
  background-color: ${COLORES.EXTRA_HEADER_BACKGROUND};
  height: 1.5rem;

  button {
    border: none;
    border-radius: 0.2rem;
    margin-left: 0.25rem;
    cursor: pointer;
    background-color: ${COLORES.SORT_BUTTON_BACKGROUND};
    background-color: ${(props) => props.active && COLORES.SORT_BUTTON_ACTIVE};

    :hover {
      background-color: ${COLORES.SORT_BUTTON_HOVER};
    }

    :disabled {
      cursor: default;
      background-color: transparent;
    }
  }
`;

export const TdFoot = styled.td`
  p,
  button {
    font-weight: bold;
    padding: 0.25rem 0.5rem;
    margin: 0.5rem;
  }
  button {
    cursor: pointer;
  }
`;

export const WrapperButtons = styled.p`
  min-width: 5rem;

  button {
  margin: 0 0 0 10px;
  height: 1.7rem;
    color: ${COLORES.BUTTON_FONT};
    background-color: ${COLORES.BUTTON_BACKGROUND};
    cursor: pointer;
    padding: 0 0.75rem;

    :active {
      transform: translate(1px, 1px);
      box-shadow: none;
    }

    :disabled {
      transform: none;
      border: solid thin ${COLORES.BUTTON_BACKGROUND_DISABLED};
      background-color: ${COLORES.BUTTON_BACKGROUND_DISABLED};
      box-shadow: 1.5px 1.5px 1px ${COLORES.BUTTON_SHADOW};
      cursor: default;
    }
  }

  button.cancel {
  border: solid thin ${COLORES.BUTTON_BACKGROUND};
    border-radius: 0.25rem;
        box-shadow: 1.5px 1.5px 1px ${COLORES.BUTTON_SHADOW};

    color: ${COLORES.BUTTON_CANCEL_FONT};
    border: solid thin ${COLORES.BUTTON_CANCEL_FONT};
    background-color: ${COLORES.BUTTON_CANCEL_BACKGROUND};

    :disabled {
      transform: none;
      border: solid thin ${COLORES.BUTTON_BACKGROUND_DISABLED};
      background-color: ${COLORES.BUTTON_BACKGROUND_DISABLED};
      box-shadow: 1.5px 1.5px 1px ${COLORES.BUTTON_SHADOW};
      cursor: default;
    }
  }

  button.approve {
    color: ${COLORES.BUTTON_FONT};
    border: solid thin ${COLORES.BUTTON_BACKGROUND};
    background-color: ${COLORES.BUTTON_BACKGROUND};

    :disabled {
      transform: none;
      border: solid thin ${COLORES.BUTTON_BACKGROUND_DISABLED};
      background-color: ${COLORES.BUTTON_BACKGROUND_DISABLED};
      box-shadow: 1.5px 1.5px 1px ${COLORES.BUTTON_SHADOW};
      cursor: default;
    }
  }

  button.deny {
    color: ${COLORES.BUTTON_DENY_FONT};
    border: solid thin ${COLORES.BUTTON_DENY_FONT};
    background-color: ${COLORES.BUTTON_DENY_BACKGROUND};

    :disabled {
      color: ${COLORES.BUTTON_FONT};
      transform: none;
      border: solid thin ${COLORES.BUTTON_BACKGROUND_DISABLED};
      background-color: ${COLORES.BUTTON_BACKGROUND_DISABLED};
      box-shadow: 1.5px 1.5px 1px ${COLORES.BUTTON_SHADOW};
      cursor: default;
    }
  }
`;
